import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/index.css';
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import LandingPage from "views/LandingPage/LandingPage.js";
import Components from "views/Components/Components.js";

var hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/landing-page" component={LandingPage} />
      <Route path="/" component={Components} />
    </Switch>
  </Router>,
  document.getElementById('root')
);
